export class UserDetailsService {
  constructor(httpClient) {
    this._httpClient = httpClient;
  }

  get(url) {
    return this._httpClient.get(url).then(({ data }) => data);
  }

  getLoggedInUserDetails() {
    return this.get(`/wix-html-login-webapp/user/getUserDetails`);
  }
}
